<template>
    <div class="step-finish-component">
        <div class="row">
            <div class="col-xs-12">
                <job :job="job" v-if="job" />
                <h2>Bewerbung versendet</h2>
                <div class="box-container">
                    <i class="fa fa-check"></i>Vielen Dank, Ihre Bewerbung wurde erfolgreich versendet!
                    <div style="margin-top: 20px;">
                        Wir melden uns schnellstmöglich bei Ihnen unter den von Ihnen angegebenen Kontaktdaten.
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12">
                        <div @click="$emit('submit')" class="btn btn-green btn-big submit">zu b-plast2000.de</div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Job from './job';

export default {
    data() {
        return {
            job: '',
        }
    },

    components: {
        Job,
    },
    mounted() {
        this.job = this.$store.state.job;

        this.$store.commit('clear');

        this.$store.state.job = this.job;
    },
}
</script>

<style lang="scss">
@import "../scss/_vars";

.step-finish-component {
    .box-container {
        padding: 16px;
        background-color: #ffffff;
        margin-bottom: 50px;
        font-size: 14px;
        color: #3a3a3a;
        box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);

        @media (min-width: map-get($breakpoints, 'md')) {
            padding: 32px;
            font-size: 16px;
            line-height: 2;
        }

        .fa {
            padding-right: 10px;
        }
    }
}
</style>
